import React from "react";
import { Check } from "@phosphor-icons/react";
import { Reveal, SectionLabel } from "./motion";
import { useLang } from "@/LanguageContext";
import { IMAGES } from "@/content";

export default function WhyMagis() {
  const { t } = useLang();
  return (
    <section id="why" data-testid="why-section" className="relative py-24 lg:py-36 bg-navy overflow-hidden">
      <div className="absolute -left-40 bottom-0 w-[36rem] h-[36rem] glow-teal rounded-full blur-3xl opacity-50" />
      <div className="relative mx-auto max-w-[1400px] px-6 lg:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-6">
          <Reveal><SectionLabel>{t.whyMagis.eyebrow}</SectionLabel></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-white mt-6 tracking-[-0.01em]">{t.whyMagis.title}</h2>
          </Reveal>
          <div className="mt-12 space-y-8">
            {t.whyMagis.items.map((item, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <div className="flex items-start gap-5 border-t border-white/10 pt-8">
                  <span className="mt-1 shrink-0 grid place-items-center w-8 h-8 rounded-full bg-gold">
                    <Check weight="bold" size={16} className="text-navy" />
                  </span>
                  <div>
                    <h3 className="font-serif text-xl sm:text-2xl text-white">{item.title}</h3>
                    <p className="text-white/60 leading-relaxed mt-3">{item.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
        <div className="lg:col-span-6">
          <Reveal delay={0.1} y={60}>
            <div className="img-zoom relative aspect-[4/5] rounded-sm border border-white/10">
              <img src={IMAGES.meeting} alt="Magis Belgium team" className="w-full h-full object-cover rounded-sm" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy/70 to-transparent rounded-sm" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
